import React, { memo, useEffect } from 'react'
import NProgressBar from 'nprogress'
import Router from 'next/router'

import { theme } from '../../theme'
import NProgressStyle from './NProgress.style'

export interface NProgressProps {
  height?: string | number
  color?: string
  delay?: number
  easing?: string
  speed?: number
  minimum?: number
  trickle?: boolean
  trickleSpeed?: number
  showSpinner?: boolean
}

export const NProgress = ({
  height = '5px',
  color = theme.colors.pink['500'],
  delay = 0,
  easing,
  speed,
  minimum,
  trickle,
  trickleSpeed,
  showSpinner = false,
}: NProgressProps) => {
  NProgressBar.configure({
    easing,
    speed,
    minimum,
    trickle,
    trickleSpeed,
    showSpinner,
  })

  useEffect(() => {
    let timeout

    const start = () => {
      timeout = setTimeout(() => NProgressBar.start(), delay)
    }

    const end = () => {
      clearTimeout(timeout)
      NProgressBar.done()
    }

    Router.events.on('routeChangeStart', start)
    Router.events.on('routeChangeComplete', end)
    Router.events.on('routeChangeError', end)

    return () => {
      clearTimeout(timeout)

      Router.events.off('routeChangeStart', start)
      Router.events.off('routeChangeComplete', end)
      Router.events.off('routeChangeError', end)
    }
  }, [])

  return <NProgressStyle color={color} height={height} />
}

export default memo(NProgress)
